(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      var AnnouncementElement = document.querySelector('.announcement-bar-section');
      
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');

        /* for sticky announcement bar */ 
         if(AnnouncementElement){
           var AnnouncementElementHeight = AnnouncementElement.offsetHeight;
            AnnouncementElement.classList.add('shopify-announcement-bar-sticky');
           document.querySelector('.shopify-section-header-sticky').style.top = AnnouncementElementHeight+'px';
         }
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

        /* set Announcement Height */ 
      var IsAnnouncementEnabled = document.querySelector('.announcement-bar-section');
      if(IsAnnouncementEnabled){
         document.documentElement.style.setProperty('--announcement-height', `${IsAnnouncementEnabled.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

       var IsAnnouncementEnabled1 = document.querySelector('.announcement-bar-section');
      if(IsAnnouncementEnabled1){
      this.header.classList.add('sticky-announcement-enabled');
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if(IsAnnouncementEnabled1){ document.querySelector('.announcement-bar-section').classList.add('scrolled-past-announcement-bar'); }
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if(IsAnnouncementEnabled1){document.querySelector('.announcement-bar-section').classList.add('scrolled-past-announcement-bar'); }
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if(IsAnnouncementEnabled1){document.querySelector('.announcement-bar-section').classList.remove('scrolled-past-announcement-bar'); }
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');

      /* Hide onScroll announcement bar */     
      var IsAnnouncementEnabled2 = document.querySelector('.announcement-bar-section');
      if(IsAnnouncementEnabled2){
      document.querySelector('.announcement-bar-section').classList.add('shopify-announcement-bar-hidden', 'shopify-announcement-bar-sticky');
      }
      
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

       /* Hide onScroll announcement bar */ 
      var IsAnnouncementEnabled2 = document.querySelector('.announcement-bar-section');
      if(IsAnnouncementEnabled2){
        document.querySelector('.announcement-bar-section').classList.add('shopify-announcement-bar-sticky', 'animate-announcement');
        document.querySelector('.announcement-bar-section').classList.remove('shopify-announcement-bar-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      
      /* Hide onScroll announcement bar */ 
      var IsAnnouncementEnabled2 = document.querySelector('.announcement-bar-section');
      if(IsAnnouncementEnabled2){
      document.querySelector('.announcement-bar-section').classList.remove('shopify-announcement-bar-hidden', 'shopify-announcement-bar-sticky', 'animate-announcement');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* start: If header always sticky */ 
  addEventListener("resize", (event) => {    
    var AnnouncementElement1 = document.querySelector('.announcement-bar-section');
    var HeaderElement = document.querySelector('sticky-header');
    var HeaderIsAlwaysSticky = HeaderElement.getAttribute('data-sticky-type') === 'always' || HeaderElement.getAttribute('data-sticky-type') === 'reduce-logo-size';    
      if (HeaderIsAlwaysSticky) {          
        if(AnnouncementElement1){
         var AnnouncementElementHeight1 = AnnouncementElement1.offsetHeight;          
         document.querySelector('.shopify-section-header-sticky').style.top = AnnouncementElementHeight1+'px';
       }
      }    
  });
 /* end: If header always sticky */ 


  

  } catch(e) { console.error(e); }
})();
})();
